<p-confirmDialog></p-confirmDialog>
<p-fileUpload #fileUpload mode="advanced" name="files" [multiple]="true" [showCancelButton]="false"
    uploadLabel="Upload" i18n-uploadLabel="@@media-upload.buttons.upload" chooseLabel="Choose Files"
    i18n-chooseLabel="@@media-upload.buttons.choose" (onSelect)="onSelect($event)" (onRemove)="onRemove($event)"
    [customUpload]="true" [accept]="accept" [showUploadButton]="uploadStatus.running == false"
    (uploadHandler)="doUpload($event)">

    <ng-template  pTemplate="toolbar">
        <span class="text-right" *ngIf="files.length>0 && !uploadStatus.running">
            <button pButton label="Remove all" i18n-label="@@media-upload.buttons.remove-all" (click)="removeAll()" class="p-button-secondary"></button>
        </span>
    </ng-template>
    <ng-template let-file pTemplate="file">
        <div class="p-fileupload-row">
            <div><img [src]="file.objectURL" *ngIf="isImage(file)" [width]="100" /></div>
            <div class="p-fileupload-filename">{{file.name}}</div>
            <div>{{formatSize(file.size)}}</div>
            <div>
                <p-button type="button" icon="far fa-trash" (click)="remove(file)" severity="danger"
                    [disabled]="uploadStatus.running" *ngIf="!uploadStatus.progress[file.name]"></p-button>
                <ng-container *ngIf="!uploadStatus.running && uploadStatus.progress[file.name]">
                    <i class="far fa-check " style="font-size: 2rem" [ngStyle]="{color:'var(--green-500)'}"
                        *ngIf="uploadStatus.progress[file.name]?.status==200"></i>
                    <i class="far fa-trash p-error" style="font-size: 2rem"
                        *ngIf="uploadStatus.progress[file.name]?.status!=200"></i>
                </ng-container>
            </div>
        </div>
        <p-message severity="info" *ngIf="file.exist">
               <div i18n="@@media-upload.fileexist">This file already exists and will be overwritten.</div>
        </p-message>
        <p-message severity="error" *ngIf="uploadStatus.progress[file.name]?.message">
            <ng-template pTemplate>
                {{uploadStatus.progress[file.name].message}}
            </ng-template>
        </p-message>
        <div style="position: relative;height:20px; margin-bottom: 20px;" *ngIf="uploadStatus.progress[file.name] && uploadStatus.running">
            <p-progressBar [value]="uploadStatus.progress[file.name].completed" [style]="{'height': '20px'}">
            </p-progressBar>
        </div>
    </ng-template>
    <ng-template pTemplate="content" let-files>
        <div class="card" *ngIf="files.length==0">
            <div class="flex flex-wrap align-items-center justify-content-center card-container">
                <p class="font-italic" i18n="@@media-upload.dragdrop">Drag one or more files into the Drop Zone ...</p>
            </div>
        </div>
    </ng-template>
</p-fileUpload>